// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__G6DuN","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2CFzS"};